<template>
  <v-card height="100%">
    <v-card-text class="py-2 full-height d-flex flex-column">
      <v-row dense>
        <v-col
          cols="auto"
          class="subtitle-1 lighttext--text my-auto"
          style="opacity: 0;"
        >
          Add Custom Field
          <v-btn icon>
            <v-icon>
              lock
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" class="pa-0">
          <v-card-title class="py-0 px-1 secondary--text">
            Add Custom Field
          </v-card-title>
        </v-col>
      </v-row>
      <v-row dense align="end" class="fill-height">
        <v-col cols="12">
          <v-btn block outlined color="secondary" @click="$emit('add')">
            <v-icon class="mr-2">add_circle</v-icon> Add Custom Field
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  name: "AddCustomFieldCard",
  data: () => ({}),
  computed: {
    ...mapGetters({})
  },
  created() {},
  methods: {}
};
</script>
